import React from 'react'

import RoundBlueButton from '../BorderButton/round-blue-button'

import PauseIcon from '../Icons/control-pause'
import PlayIcon from '../Icons/control-play'
import FaPencil from 'react-icons/lib/fa/pencil'
import FaTrash from 'react-icons/lib/fa/trash'
import { getDmp, getDmpProduct, parseDmpClientId } from '../../lib/format-dmps'
import ReactTooltip from 'react-tooltip'
import { isAdmin } from '../../lib/check-user'

const LicenseStatus = ({ status }) => (
    <div className="license-status">
        <span className={`ball ${status}`} /> {status}
    </div>
)

const PropertyRevenueRow = ({ license, max, onToggleLicense, onEdit, onHistory, onShowEdit }) => (
    <tr className="license-list license-list--row">
        {!onShowEdit && (
            <td className="license-list license-list--audience">
                <a href={'/licenses?filter=' + license.licenseId}>{license.licenseId}</a>
            </td>
        )}
        {onShowEdit && <td className="license-list license-list--audience">{license.licenseId}</td>}
        {/* 
        <td className="license-list license-list--audience">{license.licenseName}</td>
        */}
        <td className="license-list license-list--audience">
            <a href={'/audiences?filter=' + license.audienceId}>{license.audienceName}</a>
        </td>
        <td className="license-list license-list--partnerid" style={{'padding': '10px',}}>
            <b style={{
                'fontSize': '15px',
            }}>{getDmp(license.dmp)}</b>
        

        {license.dmpProductId  && (

            <div style={{
                color: 'gray',
                'font-size': '13px',
                maxWidth: '450px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                'color': '#56564c',
                'fontStyle': 'italic',
                'padding-top': '5px',
                'white-space': 'nowrap',

            }}>
                Product: {getDmpProduct(license.dmpProductId)} <br/>
                Client ID: {parseDmpClientId(license.dmpClientId)} <br/>
                Segment ID: {license.dmpSegmentId} <br/>

            </div>

            )}

        
        </td>
        {/* 
        <td className="license-list license-list--partnerid">{getDmpProduct(license.dmpProductId)}</td>
        <td className="license-list license-list--partnerid">{license.dmpSegmentId}</td>
        <td className="license-list license-list--partnerid" style={{'whiteSpace': 'nowrap'}}>{parseDmpClientId(license.dmpClientId)}</td>
        */}
        <td className="license-list license-list--cpm">
            {parseFloat(license.cpmCost / 1000000).toFixed(2)} {license.currency}
        </td>
        {/*
        <td className="license-list license-list--size">
            <AudienceSize size={license.size || 0} />
        </td>
        */}
        <td className="license-list license-list--size">{new Date(license.validUntil).toDateString()}</td>
        <td className="license-list license-list--status">
            <LicenseStatus status={license.status} />
        </td>
        {onShowEdit && (
            <td className="license-list license-list--actions">
                <div className="action-wrapper">
                    <ReactTooltip id="editBtnTooltip" type="dark" effect="solid">
                        <span>Edit license</span>
                    </ReactTooltip>
                    <ReactTooltip id="toggleBtnTooltip" type="dark" effect="solid">
                        <span>Toggle license</span>
                    </ReactTooltip>
                    <ReactTooltip id="deleteBtnTooltip" type="dark" effect="solid">
                        <span>Delete license</span>
                    </ReactTooltip>
                    <ReactTooltip id="logBtnTooltip" type="dark" effect="solid">
                        <span>License events</span>
                    </ReactTooltip>
                    <RoundBlueButton data-tip data-for="editBtnTooltip" className="very-blue" icon={<FaPencil />} onClick={() => onEdit(license)} />
                    &#160; &#160;
                    <RoundBlueButton
                        data-tip
                        data-for="toggleBtnTooltip"
                        className="very-blue"
                        icon={license.status === 'active' ? <PauseIcon /> : <PlayIcon />}
                        onClick={() => onToggleLicense(license)}
                    />

                </div>
            </td>
        )}
    </tr>
)

export default PropertyRevenueRow
